/**
 * @fileoverview Component Price
 * @version 1.0
 * @author Carlos Emilio Blanco Lopez
 * @date 14/02/2023
 * @copyright 2023 Industrias RESSER S.A de C.V
 */

import React, { useEffect, useState } from "react";
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { useAppSelector } from "../../hooks/storeHooks";
import { useAppDispatch } from "../../hooks/storeHooks";
import { formatNumber } from "../../functions/formatPrice";
import styles from "./ComponentPrice.style";
import { setLeasingResultCotizacion } from "../../reducer/slices/DataResponse";
import { Spin } from "antd";

const useStyles = styles;

/**
 * @title ComponentPrice
 * @returns Fragment
 */

const ComponentPrice = () => {

    const classes = useStyles();

    const { LeasingResultCotizacion, ObjActivo } = useAppSelector(state => state.DataResponse);
    const dispatch = useAppDispatch();
    const dataCotizacion = useAppSelector(state => state.DataCotizador);
    const isLoading = useAppSelector(state => state.DataCotizador.isLoadingData);
    const Activo = ObjActivo.length === 0 ? '' : ObjActivo.filter(e => e.id === dataCotizacion.userActivo)[0].name
    const [Desglose, setDesglose] = useState<boolean>(false);

    const plazo = () => {
        switch (dataCotizacion.userPlazo) {
            case 0:
                return '12'
            case 1:
                return '24'
            case 2:
                return '36'
            case 3:
                return '48'
            case 4:
                return '60'
            default:
                return '12'
        }
    }
    
    useEffect(() => {
        const result = {
            rent: 0,
            pagoInicial: 0,
            montoFinanciado: 0,
            valorEquipo: 0,
            seguroPrimerAno: 0,
            comisionApertura: 0,
            Anticipo: 0,
            AdvanceRent:0,
            AdvanceCommision:0
        }
        if (dataCotizacion.assetPrice === 0) {
            dispatch(setLeasingResultCotizacion(result));

        }
    }   , [dataCotizacion.assetPrice])

    return (
        <Spin spinning={isLoading} size="large">
        <div
            className={
                Desglose ?
                    classes.ContainerDesglose :
                    classes.Container
            }
        >
            <div className={classes.Content}>
                <p className={classes.txtTitlePrice}>{Activo}</p>
                <p className={classes.txtSubtitlePrice}>{`${plazo()} pagos de:`}</p>
                <p className={classes.txtCostoPrice}>{`$${formatNumber(LeasingResultCotizacion.rent)}`}</p>
                <p className={classes.txtIvaPrice}>No incluye IVA</p>
                <p className={classes.txtSubtitlePrice}>Pago inicial:</p>
                <p className={classes.txtCostoPrice}>{`$${formatNumber(LeasingResultCotizacion.pagoInicial)}*`}</p>

                        <div className={classes.txtAdicional}>
                            <p className={classes.txtMontoFinanciado}>Monto financiado</p>
                            <p className={classes.txtMontoFinanciadoPrice}>
                                {`$${formatNumber(LeasingResultCotizacion.montoFinanciado)}`}
                            </p>
                        </div>

                            <div
                                style={{ marginTop: '15%' }}
                                className={classes.txtAdicional}>
                                <p>Valor del equipo </p>
                                <div>
                                    <p style={{ marginBottom: '15%' }} className={classes.txtAdicionalPrice}>{`$${formatNumber(LeasingResultCotizacion.valorEquipo)} *`}</p>
                                </div>
                            </div>
                            <div className={classes.txtAdicional}>
                                <p>Comisión por apertura </p>
                                <p className={classes.txtAdicionalPrice}>{`$${formatNumber(LeasingResultCotizacion.comisionApertura)}`}</p>
                            </div>
                            <div className={classes.txtAdicional} style={{marginBottom: 10}}>
                                <p>Anticipo </p>
                                <p className={classes.txtAdicionalPrice}>{`$${formatNumber(LeasingResultCotizacion.Anticipo)}`}</p>
                            </div>
                            <div className={classes.txtAdicional}>
                                <p>* Monto con iva incluido.</p>
                            </div>
                            <div className={classes.txtAdicional} style={{marginBottom: 1}}>
                                <p>* Contempla el anticipo y comisión con iva incluido</p>
                            </div>
                            <div className={classes.txtAdicional} style={{marginBottom: 1}}>
                                <p>El seguro se cotizará al momento de la contratación</p>
                            </div>
                <p className={classes.txtMontoFinanciadoPrice}>Descarga tu simulación al finalizar el proceso.</p>
            </div>
        </div>
        </Spin>
    );
}

export default ComponentPrice;